var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderHistory"},[_c('order-address',{attrs:{"site":_vm.site}}),_c('in-the-lease',{attrs:{"listData":_vm.allData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }